import React, { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../lib/firebase";
import Withdraw from "../components/dashboard/Withdraw";
import Loader from "../components/Loader";
import Funding from "../components/stocks/Funding";

function FxtWithdraw({ user }) {
  const [accountBalances, setAccountBalances] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          const transactions = userData.transactions || [];

          const balances = {};
          transactions.forEach((txn) => {
            if (!balances[txn.account]) {
              balances[txn.account] = 0;
            }
            if (txn.type === "credit") {
              balances[txn.account] += txn.amount;
            } else if (txn.type === "debit") {
              balances[txn.account] -= txn.amount;
            }
          });

          setAccountBalances(balances);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (user && user.uid) {
      fetchData();
    }
  }, [user]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="skyfxt-box fxt-deposit">
      <Withdraw user={user} accountBalances={accountBalances} />
      <Funding />
    </div>
  );
}

export default FxtWithdraw;
